import React, { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import BcSepIcon from "../../../asset/images/about/breadcrumb-separator.svg";
import HeroBgImg      from "../../../asset/images/power&surveillance/hp-series/hero-bg.webp";
import HeroMobileImg  from "../../../asset/images/power&surveillance/hp-series/hero-bg-mobile.webp";
import Ups1Img   from "../../../asset/images/power&surveillance/hp-series/ups-1-3kva.webp";
import Ups2Img   from "../../../asset/images/power&surveillance/hp-series/ups-6-10kva.webp";
import Ups3Img   from "../../../asset/images/power&surveillance/hp-series/ups-10-20kva.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .hp { font-family: 'Poppins', sans-serif; color: #202020; background: #fff; }

  .hp-hero {
    position: relative;
    width: 100%;
    height: 465px;
    overflow: hidden;
    background: #111;
  }
  .hp-hero-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }
  .hp-hero-bg-mobile {
    display: none;
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
  .hp-hero-content {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 102px;
    max-width: 1600px;
    margin: 0 auto;
    left: 0; right: 0;
  }
  .hp-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px;
    font-weight: 600;
    color: #000000;
    line-height: 140%;
    max-width: 524px;
  }
  .hp-hero-title em {
    font-style: normal;
    color: #EB2019;
  }

  /* SUBNAV */
  .hp-subnav {
    width: 100%;
    background: #EB2019;
    position: sticky;
    top: 162px;
    z-index: 100;
    overflow: visible;
  }
  .hp-anchor { scroll-margin-top: 180px; }
  .hp-subnav-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: stretch;
    white-space: nowrap;
    overflow: visible;
  }
  .hp-subnav-item {
    position: relative;
    flex-shrink: 0;
  }
  .hp-subnav-link {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #fff;
    text-decoration: none;
    cursor: pointer;
    transition: background 0.15s;
    border: 1px solid #A40000;
    background: #B91E1A;
    white-space: nowrap;
    height: 100%;
  }
  .hp-subnav-link.hp-active { font-weight: 500; }
  .hp-subnav-link:hover { background: rgba(0,0,0,0.15); }
  .hp-subnav-chevron {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-right: 2px solid rgba(255,255,255,0.9);
    border-bottom: 2px solid rgba(255,255,255,0.9);
    transform: rotate(45deg) translateY(-2px);
    flex-shrink: 0;
    transition: transform 0.2s;
  }
  .hp-subnav-chevron.open {
    transform: rotate(-135deg) translateY(-2px);
  }

  /* DROPDOWN — position:absolute under nav item */
  .hp-subnav-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    min-width: 312px;
    background: #fff;
    border: 1px solid #7A7A7A;
    z-index: 9999;
  }
  .hp-subnav-dropdown-item {
    display: block;
    padding: 15px 24px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    text-decoration: none;
    border-bottom: 1px solid #EB2019;
    transition: background 0.15s;
    cursor: pointer;
  }
  .hp-subnav-dropdown-item:last-child { border-bottom: none; }
  .hp-subnav-dropdown-item:hover { background: #f9f9f9; color: #EB2019; }
  .hp-subnav-dropdown-item.hp-dd-active { color: #EB2019; font-weight: 500; }

  /* MOBILE BAR */
  .hp-mobile-bar {
    display: none;
    width: 100%;
    background: #B91E1A;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    height: 56px;
    position: sticky;
    top: 72px;
    z-index: 100;
  }
  .hp-mobile-bar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
  }
  .hp-hamburger {
    display: flex;
    flex-direction: column;
    gap: 5px;
    cursor: pointer;
    background: none;
    border: none;
    padding: 4px;
  }
  .hp-hamburger span {
    display: block;
    width: 22px;
    height: 2px;
    background: #fff;
    border-radius: 2px;
  }

  /* MOBILE SIDEBAR */
  .hp-sidebar-overlay {
    display: none;
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.4);
    z-index: 500;
  }
  .hp-sidebar-overlay.open { display: block; }
  .hp-sidebar {
    position: fixed;
    top: 80px;
    left: 0;
    width: 275px;
    max-width: 100vw;
    height: 614px;
    background: #fff;
    z-index: 600;
    display: flex;
    flex-direction: column;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
    overflow-y: auto;
    border:1px solid #7A7A7A;
  }
  .hp-sidebar.open { transform: translateX(0); }
  .hp-sidebar-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #B91E1A;
    padding: 0 20px;
    height: 56px;
    flex-shrink: 0;
  }
  .hp-sidebar-header-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
  }
  .hp-sidebar-close {
    background: none;
    border: none;
    cursor: pointer;
    color: #fff;
    font-size: 22px;
    line-height: 1;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .hp-sidebar-nav { flex: 1; overflow-y: auto; }
  .hp-sidebar-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 24px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    border-bottom: 0.7px solid #7A7A7A;
    cursor: pointer;
    background: none;
    border-left: none;
    border-right: none;
    border-top: none;
    width: 100%;
    text-align: left;
    text-decoration: none;
  }
  .hp-sidebar-row:hover { background: #fafafa; }
  .hp-sidebar-row.active { color: #000000; font-weight: 400; }
  .hp-sidebar-chevron {
    display: inline-block;
    width: 9px;
    height: 9px;
    border-right: 2px solid #888;
    border-bottom: 2px solid #888;
    transform: rotate(45deg) translateY(-2px);
    flex-shrink: 0;
    transition: transform 0.2s;
  }
  .hp-sidebar-chevron.open {
    transform: rotate(-135deg) translateY(-2px);
  }
  .hp-sidebar-subitems { border-bottom: 1px solid #efefef; }
  .hp-sidebar-subitem {
    display: block;
    padding: 8px 59px 8px 46px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 300;
    color: #202020;
    text-decoration: none;
    border-bottom: 0.7px solid #EB2019;
    cursor: pointer;
  }
  .hp-sidebar-subitem:last-child { }
  .hp-sidebar-subitem:hover { background: #fafafa; }
  .hp-sidebar-subitem.active { color: #B91E1A; font-weight: 400; }

  /* BREADCRUMB */
  .hp-breadcrumb { padding: 60px 0 0 0; }
  .hp-breadcrumb-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 14px;
  }
  .hp-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #202020;
    text-decoration: none;
    transition: color 0.15s;
  }
  .hp-bc-item:hover { color: #EB2019; }
  .hp-bc-item.active { color: #202020; }
  .hp-bc-sep {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin: 0 8px;
    flex-shrink: 0;
  }

  /* INNER */
  .hp-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
  }

  /* DIVIDER */
  .hp-divider {
    max-width: 1600px;
    margin: 0 auto;
    padding: 80px 102px 0px 102px;
  }
  .hp-divider hr {
    border: none;
    border-top: 1px solid #EB2019;
    opacity: 0.3;
  }
  .hp-divider-slim {
    max-width: 1600px;
    margin: 0 auto;
    padding: 60px 102px 0 102px;
  }
  .hp-divider-slim hr {
    border: none;
    border-top: 1px solid #EB2019;
    opacity: 0.3;
  }

  /* CONTENT */
  .hp-section-content { padding: 80px 0 0 0; }
  .hp-content-grid {
    display: flex;
    gap: 80px;
    align-items: center;
  }
  .hp-content-left { flex: 0 0 766px; }
  .hp-img-col {
    flex: 1;
    align-self: stretch;
    background: #F5F5F5;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .hp-img-wrap {
    width: 100%;
    height: 100%;
    max-height: 650px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .hp-product-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }
  .hp-red-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px;
    font-weight: 600;
    color: #EB2019;
    margin-bottom: 24px;
    line-height: 120%;
  }
  .hp-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 600;
    color: #202020;
    margin-bottom: 14px;
  }
  .hp-para {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #7A7A7A;
    line-height: 140%;
  }
  .hp-para + .hp-para { margin-top: 14px; }
  .hp-features-tag {
    display: inline-flex;
    align-items: stretch;
    margin: 34px 0 34px 0;
  }
  .hp-features-tag-bar {
    width: 10px;
    background: #EB2019;
    flex-shrink: 0;
  }
  .hp-features-tag-text {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #202020;
    background: #FFE6E5;
    padding: 18px 27px;
  }
  .hp-features-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .hp-features-list li {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
    padding: 4px 0 4px 20px;
    position: relative;
  }
  .hp-features-list li::before {
    content: '•';
    position: absolute;
    left: 0;
    color: #202020;
  }

  /* ══ RESPONSIVE 768px ══ */
  @media (max-width: 768px) {
    .hp-hero-bg        { display: block; }
    .hp-content-grid:last-child { margin-bottom: 40px !important;}
    .hp-subnav {top: 70px;}
    .hp-anchor { scroll-margin-top: 110px; }
    .hp-subnav-inner   { padding: 0 16px; overflow-x: auto; }
    .hp-subnav-link    { padding: 16px 14px; font-size: 13px; }
    .hp-hero              { height: 300px; }
    .hp-hero-content      { padding: 0 32px; }
    .hp-hero-title        { font-size: 26px; }
    .hp-breadcrumb        { padding: 28px 0 0 0; }
    .hp-breadcrumb-inner  { padding: 0 24px; }
    .hp-inner             { padding: 0 24px; }
    .hp-divider           { padding: 0px 32px 0px 32px; }
    .hp-divider:last-child { display: none; }
    .hp-divider-slim      { padding: 20px 24px 0 24px; }
    .hp-section-content   { padding: 40px 0 0 0; }
    .hp-content-grid      { flex-direction: column-reverse !important; gap: 30px; }
    .hp-content-left      { flex: none; width: 100%; }
    .hp-features-tag      { margin: 24px 0 24px 0; }
    .hp-features-tag-text { font-size: 14px; padding: 14px 24px; }
    .hp-img-col           { min-height: 260px; width: 100%; }
    .hp-img-wrap          { max-height: 450px; }
    .hp-red-title         { font-size: 24px; margin-bottom: 10px; }
    .hp-subtitle          { font-size: 18px; margin-bottom: 10px; }
    .hp-para              { font-size: 14px; }
    .hp-para + .hp-para   { margin-top: 10px; }
    .hp-features-list li  { font-size: 14px; }
  }

  /* ══ RESPONSIVE 480px ══ */
  @media (max-width: 480px) {
    .hp-subnav         { display: none; }
    .hp-mobile-bar     { display: flex; height: 46px; }
    .hp-sidebar-header { height: 46px;}
    .hp-anchor { scroll-margin-top: 80px; }
    .hp-hero-bg        { display: none; }
    .hp-hero-bg-mobile { display: block; }
    .hp-hero              { height: 370px; }
    .hp-hero-content      { padding: 0 16px; justify-content: flex-start; padding-top:76px; }
    .hp-hero-title        { font-size: 22px; }
    .hp-breadcrumb        { padding: 22px 0 0 0; }
    .hp-breadcrumb-inner  { padding: 0 16px; gap: 6px; }
    .hp-bc-item           { font-size: 14px; }
    .hp-bc-sep            { width: 18px; height: 18px; margin: 0 4px; }
    .hp-inner             { padding: 0 16px; }
    .hp-divider           { padding: 0px 16px; }
    .hp-divider-slim      { padding: 30px 16px 0 16px; }
    .hp-section-content   { padding: 60px 0 0 0; }
    .hp-section-content:last-child { padding: 60px 0 0px 0; }
    .hp-divider:last-child { display: none; }
    .hp-content-grid:last-child { margin-bottom: 60px !important; }
    .hp-content-grid      { gap: 30px; flex-direction: column-reverse !important; }
    .hp-img-wrap          { max-height: 260px; }
    .hp-red-title         { font-size: 20px; margin-bottom: 20px; }
    .hp-subtitle          { font-size: 16px; margin-bottom: 20px; }
    .hp-para              { font-size: 14px; }
    .hp-features-list li  { font-size: 14px; }
  }
`;

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const SUBNAV = [
  {
    label: "HP Series",
    chevron: true,
    active: true,
    href: "power-surveillance/hp-series",
    children: [
      { label: "HP SERIES (1 KVA To 3 KVA ONLINE UPS)", anchor: "hp-product-1", active: true },
      { label: "HP SERIES (6 KVA To 10 KVA)",           anchor: "hp-product-2" },
      { label: "HP SERIES (10 KVA To 20 KVA)",          anchor: "hp-product-3" },
    ],
  },
  { label: "Prime & Master Series", chevron: false, href: "/power-surveillance/prime-master-series" },
  {
    label: "Liferaft Modular",
    chevron: true,
    href: "/power-surveillance/liferaft-modular",
    children: [
      { label: "Liferaft Modular 10 KVA", href: "/power-surveillance/liferaft-modular#liferaft-10" },
      { label: "Liferaft Modular 20 KVA", href: "/power-surveillance/liferaft-modular#liferaft-20" },
      { label: "Liferaft Modular 40 KVA", href: "/power-surveillance/liferaft-modular#liferaft-40" },
    ],
  },
  { label: "Power+ Series", chevron: false, href: "/power-surveillance/power-plus-series" },
  { label: "Liferaft",      chevron: false, href: "/power-surveillance/liferaft" },
  {
    label: "Star+ Tx Series",
    chevron: true,
    href: "/power-surveillance/star-tx-series",
    children: [
      { label: "STAR Tx SERIES (6 KVA – 40 KVA)",    href: "/power-surveillance/star-tx-series#st-product-1" },
      { label: "STAR+ Tx SERIES (10 KVA – 300 KVA)",  href: "/power-surveillance/star-tx-series#st-product-2" },
    ],
  },
  { label: "Star+ Series",                                   chevron: false, href: "/power-surveillance/star-plus-series" },
  { label: "Star+ Series Microcontroller Based Stabilizers", chevron: false, href: "/power-surveillance/star-plus-series-microcontroller-stabilizers" },
];

const PRODUCTS = [
  {
    id: 1,
    anchor: "hp-product-1",
    title:    "HP SERIES (1 KVA To 3 KVA ONLINE UPS)",
    subtitle: "1:1 Phase PF : 0.8/0.9",
    paras: ["HP Series 1 to 3 kVA UPS system is a online double conversion high frequency transformerless design. The system is fully Microprocessor based with wide input voltage range suitable for Indian power conditions. HP UPS commits Advanced PFC technology with Intelligent Battery Management System."],
    features: [
      "UPS start up without battery",
      "Input power factor correction",
      "Cold start function",
      "Generator compatible",
      "High frequency & double conversion on-line technology",
      "Digitized Microprocessor control  optimizes reliability",
      "Wide input voltage range",
      "Inbuilt / external battery options",
      "Compatible with Lithium-ion Battery and BMS",
    ],
    imgRight: true,
    imgSrc: Ups1Img,
  },
  {
    id: 2,
    anchor: "hp-product-2",
    title:    "HP SERIES (6 KVA To 10 KVA)",
    subtitle: "1:1 Phase PF : 0.8/0.9",
    paras: ["HP Series 6 to10 kVA UPS system is a on-line double conversion high frequency transformerless design. The system is fully Microprocessor based with wide input voltage range suitable for Indian power conditions. HP UPS commits Advanced PFC technology with Intelligent Battery Management System."],
    features: [
      "N+ parallel redundancy",
      "Online double conversion with DSP control",
      "Input current harmonic : <3%",
      "Optimization battery group, the quantity of battery : 16/18/20 pieces (optional)",
      "High output power factor at 0.8 / 0.9 PF",
      "Wide input voltage range: 120 ~ 276Vac",
      "Wide input frequency range  (50Hz: 45-55Hz/ 60Hz: 54-66Hz)",
      "Compatible with Lithium-ion Battery and BMS",
      "Generator compatible",
      "Support economic (ECO) operation mode",
      "Self-testing when UPS Startup",
      "Options: SNMP / Parallel / Dry contact",
      "Cold Start",
    ],
    imgRight: false,
    imgSrc: Ups2Img,
  },
  {
    id: 3,
    anchor: "hp-product-3",
    title:    "HP SERIES (10 KVA To 20 KVA)",
    subtitle: "3:1 Phase PF : 0.8/0.9",
    paras: ["HP Series 1 to 3 kVA UPS system is a online double conversion high frequency transformerless design. The system is fully Microprocessor based with wide input voltage range suitable for Indian power conditions. HP UPS commits Advanced PFC technology with Intelligent Battery Management System."],
    features: [
      "N+ parallel redundancy",
      "Online double conversion with DSP control",
      "Input current harmonic : <5%",
      "Optimization battery group, the quantity of battery : 16/18/20  pieces (optional)",
      "Factor is changed when selection of different battery quantity 16pc:0.7PF;  18PCS:0.8PF, 20PCS:0.9PF",
      "Wide input voltage range: 208 ~ 478Vac",
      "Wide input frequency range (50Hz: 45-55Hz/ 60Hz: 54-66Hz)",
      "Generator compatible",
      "Support economic (ECO) operation mode",
      "Self-testing when UPS Startup",
      "Options: SNMP card/Relay card/Parallel Card",
      "Cold Start",
    ],
    imgRight: true,
    imgSrc: Ups3Img,
  },
];

/* ── SubnavItem — position:absolute dropdown, hover via onMouseEnter/Leave on wrapper ── */
function SubnavItem({ item }) {
  const [open, setOpen] = useState(false);

  if (!item.chevron || !item.children?.length) {
    return (
      <div className="hp-subnav-item">
        <a
          href={item.href || "#"}
          className={`hp-subnav-link${item.active ? " hp-active" : ""}`}
        >
          {item.label}
        </a>
      </div>
    );
  }

  return (
    <div
      className="hp-subnav-item"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <a
        href={item.href || "#"}
        className={`hp-subnav-link${item.active ? " hp-active" : ""}`}
      >
        {item.label}
        <span className={`hp-subnav-chevron${open ? " open" : ""}`} />
      </a>
      {open && (
        <div className="hp-subnav-dropdown">
          {item.children.map((child, i) => (
            <a
              key={i}
              href={child.href || `#${child.anchor}`}
              className={`hp-subnav-dropdown-item${child.active ? " hp-dd-active" : ""}`}
              onClick={(e) => {
                if (child.anchor && !child.href) {
                  e.preventDefault();
                  scrollTo(child.anchor);
                }
                setOpen(false);
              }}
            >
              {child.label}
            </a>
          ))}
        </div>
      )}
    </div>
  );
}

function SidebarRow({ item, onClose }) {
  const [open, setOpen] = useState(item.active && item.children?.length > 0);

  if (!item.chevron || !item.children?.length) {
    return (
      <a href={item.href || "#"} className={`hp-sidebar-row${item.active ? " active" : ""}`} onClick={onClose}>
        {item.label}
      </a>
    );
  }

  return (
    <>
      <button
        className={`hp-sidebar-row${item.active ? " active" : ""}`}
        onClick={() => setOpen(o => !o)}
      >
        {item.label}
        <span className={`hp-sidebar-chevron${open ? " open" : ""}`} />
      </button>
      {open && (
        <div className="hp-sidebar-subitems">
          {item.children.map((child, i) => (
            <a
              key={i}
              href={child.href || `#${child.anchor}`}
              className={`hp-sidebar-subitem${child.active ? " active" : ""}`}
              onClick={(e) => {
                if (child.anchor && !child.href) {
                  e.preventDefault();
                  onClose();
                  setTimeout(() => scrollTo(child.anchor), 320);
                } else {
                  onClose();
                }
              }}
            >
              {child.label}
            </a>
          ))}
        </div>
      )}
    </>
  );
}

export default function HpSeries() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash?.replace("#", "");
    if (!hash) return;
    const tryScroll = () => {
      const el = document.getElementById(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        setTimeout(tryScroll, 100);
      }
    };
    const timer = setTimeout(tryScroll, 300);
    return () => clearTimeout(timer);
  }, [location.hash]);

  return (
    <>
      <style>{CSS}</style>

      <div className="hp">
        <section className="hp-hero">
          <img className="hp-hero-bg" src={HeroBgImg} alt="" />
          <img className="hp-hero-bg-mobile" src={HeroMobileImg} alt="" />
          <div className="hp-hero-content">
            <h1 className="hp-hero-title">
              UNINTERRUPTED <em>POWER</em>,<br />
              UNMATCHED <em>VISION</em>
            </h1>
          </div>
        </section>
      </div>

      <nav className="hp-subnav" aria-label="Product categories">
        <div className="hp-subnav-inner">
          {SUBNAV.map((item, i) => (
            <SubnavItem key={i} item={item} />
          ))}
        </div>
      </nav>

      <div className="hp-mobile-bar">
        <span className="hp-mobile-bar-title">HP Series</span>
        <button className="hp-hamburger" onClick={() => setSidebarOpen(true)} aria-label="Open menu">
          <span /><span /><span />
        </button>
      </div>

      <div
        className={`hp-sidebar-overlay${sidebarOpen ? " open" : ""}`}
        onClick={() => setSidebarOpen(false)}
      />
      <div className={`hp-sidebar${sidebarOpen ? " open" : ""}`}>
        <div className="hp-sidebar-header">
          <span className="hp-sidebar-header-title">HP Series</span>
          <button className="hp-sidebar-close" onClick={() => setSidebarOpen(false)}>✕</button>
        </div>
        <nav className="hp-sidebar-nav">
          {SUBNAV.map((item, i) => (
            <SidebarRow key={i} item={item} onClose={() => setSidebarOpen(false)} />
          ))}
        </nav>
      </div>

      <div className="hp">
        <nav className="hp-breadcrumb" aria-label="Breadcrumb">
          <div className="hp-breadcrumb-inner">
            <a href="/" className="hp-bc-item">Home</a>
            <span className="hp-bc-sep"><img src={BcSepIcon} alt="" /></span>
            <a href="#" className="hp-bc-item">Business</a>
            <span className="hp-bc-sep"><img src={BcSepIcon} alt="" /></span>
            <span className="hp-bc-item active">Power &amp; Surveillance</span>
          </div>
        </nav>

        <div className="hp-divider-slim"><hr /></div>

        {PRODUCTS.map((product) => (
          <React.Fragment key={product.id}>
            <div id={product.anchor} className="hp-anchor" />
            <section className="hp-section-content">
              <div className="hp-inner">
                <div
                  className="hp-content-grid"
                  style={!product.imgRight ? { flexDirection: "row-reverse" } : {}}
                >
                  <div className="hp-content-left">
                    <h2 className="hp-red-title">{product.title}</h2>
                    <h3 className="hp-subtitle">{product.subtitle}</h3>
                    {product.paras.map((p, i) => (
                      <p key={i} className="hp-para">{p}</p>
                    ))}
                    <div className="hp-features-tag">
                      <div className="hp-features-tag-bar" />
                      <span className="hp-features-tag-text">Features</span>
                    </div>
                    <ul className="hp-features-list">
                      {product.features.map((f, i) => <li key={i}>{f}</li>)}
                    </ul>
                  </div>

                  <div className="hp-img-col">
                    <div className="hp-img-wrap">
                      {product.imgSrc &&
                        <img className="hp-product-img" src={product.imgSrc} alt={product.title} />
                      }
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <div className="hp-divider"><hr /></div>
          </React.Fragment>
        ))}
      </div>
    </>
  );
}